import gql from 'graphql-tag'

export default gql`
  query GameTypes($game: String) {
    game: Game(slug: $game) {
      id,
      types {
        id,
        color,
        name
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/QUERY_GAME_TYPES.js